//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ArticleTeaser    from '../article-teaser.vue';
import SearchTeaser     from './search-teaser.vue';
import Utils            from '../../utils/utils.js';

import {directive as vueOnClickAway} from 'vue-clickaway';
import _            from 'lodash';
import qs           from 'qs';
import Promise       from 'bluebird';

export default {
    props : {
        search_id : {
            required: true
        },
        pre_search_text : {
            default: ''
        },
        posts_per_page : {
            default : 12
        },
        search_running_text : {
            default : rest_options.options.translations.running
        },
        post_type_slug : {
            default : ''
        },
        post_type_name : {
            default : ''
        }
    },
    data : function () {
        return {
            offset              : 0,
            page                : '',
            initialized         : false,
            action              : {},
            search_results      : [],
            icons               : rest_options.options.icons,
            translations        : rest_options.options.translations,
            search_text         : this.pre_search_text,
            running_search      : true,
            rest_options        : rest_options,
            see_all_text        : rest_options.options.translations.see_all,
            at_maximum          : false,
            we_care_about_your_privacy : rest_options.options.translations.we_care_about_your_privacy,
            cookies_have_been_deactivated : rest_options.options.translations.cookies_have_been_deactivated,
            change_your_cookie_consent : rest_options.options.translations.change_your_cookie_consent,
        };
    },
    created : function () {
    },
    mounted : function () {
        if(this.post_type_slug == 'video') {
            this.get_youtube(this.page).then((articleTeasers) => {
                this.search_results = articleTeasers;
                this.initialized = true;
                this.running_search = false;
            });
        } else if (this.post_type_slug == 'presentation') {
            this.get_slideshare(this.offset).then((articleTeasers) => {
                this.search_results = articleTeasers;
                this.initialized = true;
                this.running_search = false;
            });
        }
    },
    methods : {
        init : function () {
        },
        get_youtube : function (page = '') {
            return new Promise((resolve, reject) => {
                this.$http.get('/wp-json/vtv/v1/search/get_youtube', {
                    params : {
                        page : page
                    }
                }).then((response) => {
                    let data = response.body;
                    let articleTeasers = [];
                    data.videos.forEach((item) => {
                        let articleTeaser = {
                            label: item.snippet.title,
                            excerpt: item.snippet.description,
                            permalink: 'https://www.youtube.com/watch?v=' + item.id.videoId,
                            embed: 'https://www.youtube.com/embed/' + item.id.videoId,
                            timestamp: item.snippet.publishedAt,
                            channel: 'YouTube',
                            post_type: {
                                label: this.post_type_name
                            }
                        }
                        articleTeasers.push(articleTeaser);
                    });
                    this.at_maximum = data.videos.length < 9;
                    this.page = data.nextPage;
                    resolve(articleTeasers);
                }, (response) => {
                    reject(response);
                });
            });
        },
        get_slideshare : function (offset = '') {
            return new Promise((resolve, reject) => {
                this.$http.get('/wp-json/vtv/v1/search/get_slideshare', {
                    params : {
                        offset : offset
                    }
                }).then((response) => {
                    let data = response.body;
                    let articleTeasers = [];
                    data.slides.forEach((item) => {
                        let articleTeaser = {
                            label: item.Title,
                            excerpt: item.Description,
                            permalink: item.URL,
                            timestamp: item.Updated,
                            channel: 'SlideShare',
                            image: {
                                url: item.ThumbnailXXLargeURL
                            },
                            post_type: {
                                label: this.post_type_name
                            }
                        }
                        articleTeasers.push(articleTeaser);
                    });
                    this.at_maximum = data.slides.length < 9;
                    this.offset = this.offset + articleTeasers.length;
                    resolve(articleTeasers);
                }, (response) => {
                    reject(response);
                });
            });
        },
        get_more_content : function (page_or_offset) {
            if (this.post_type_slug == 'video') {
                this.get_youtube(this.page).then((articleTeasers) => {
                    this.search_results = this.search_results.concat(articleTeasers);
                });
            } else if (this.post_type_slug == 'presentation') {
                this.get_slideshare(this.offset).then((articleTeasers) => {
                    this.search_results = this.search_results.concat(articleTeasers);
                });
            }
        }
    },
    directives : {
        vueOnClickAway : vueOnClickAway,
    },
    components : {
        ArticleTeaser,
        SearchTeaser
    }
};



// WEBPACK FOOTER //
// ./js/vue/search/search-module-external.vue